export const featureFlags = {
  MY_SSS: 'mysss_enabled',
};
